import { render, staticRenderFns } from "./PuiTableMenu.vue?vue&type=template&id=4207139a&scoped=true&"
import script from "./PuiTableMenu.vue?vue&type=script&lang=js&"
export * from "./PuiTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207139a",
  null
  
)

export default component.exports